<template>
  <div class="topbar">
    <div class="topbar-left">
      <Logo />
    </div>
    <Navbar />
  </div>
</template>

<script>
import Logo from "../../components/Logo/Logo";
import Navbar from "./Navbar/Navbar";
export default {
  name: "Header",
  components: {
    Logo,
    Navbar
  }
};
</script>

<style lang="scss">
.topbar {
  left: 0px;
  position: fixed;
  right: 0;
  top: 0px;
  z-index: 999;
  background-color: #36404a;
  display: flex;

  &-left {
    position: relative;
    width: 240px;
    z-index: 1;

    @media (max-width: 991px) {
      display: none;
    }
    #wrapper.enlarged & {
      width: 70px !important;
    }
  }
}
</style>
